import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {ElementoHijoMenuComponent} from "./elemento-hijo-menu.component";
import {RouterLink} from "@angular/router";

@NgModule({
  declarations: [
    ElementoHijoMenuComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterLink,
  ],
  exports: [
    ElementoHijoMenuComponent
  ],
})
export class ElementoHijoMenuModule {
}
